module.exports = __webpack_public_path__ + "static/img_life_saving_gift_banner_5_m@2x-33a32de1f562a6c7a5689b6b381ea7c6.jpg";